var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { RecordType } from '../types/api';
import { authorityTypeName } from '../components/AuthorityTypeCard/AuthorityTypeLabel';
/**
 * CZNA-1529 — every type name the authority list's type column can show, as its label names
 * them in this locale: each authority type, each vocabulary type of the registry (the type
 * filter offers them, so their rows are in the list) and any other type a row on the page has.
 * The list sizes the column for the widest of these (authorityListLayout `typeNameWidth`).
 */
export var authorityListTypeNames = function (intl, vocabularyTypeCodes, rowTypes) { return Array.from(new Set(__spreadArray(__spreadArray(__spreadArray([], Object.values(RecordType), true), vocabularyTypeCodes, true), rowTypes, true))).map(function (type) { return authorityTypeName(intl, type); }); };
export default authorityListTypeNames;
